import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserStorageService {
  setItem(key: string, value: string | number | boolean): void {
    localStorage.setItem(key, String(value));
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setObjectItem(key: string, value: unknown): void {
    this.setItem(key, JSON.stringify(value));
  }

  getObjectItem<T>(key: string): T | null {
    const item = this.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
